import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Translate, I18n } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';

import { APP_COLORS, BACKGROUND_COLOR, UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../Layout/ContentWrapper';
import checkPermission from '../Common/permissions';
import FilterByStart from '../Common/filterByStart';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { companyCodeTitle, isOLG } from '../../actions/root_url';
import { MARKET_SL_QUERY_URL } from '../../actions/url';
import { SkyLightStateless } from 'react-skylight';
import MarketingModal from '../Products/components/MarketingModal';
import { browserHistory } from 'react-router';


class RowRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    return this.props.row.IsStopSale === 'yes' ? BACKGROUND_COLOR.red : 'black';
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        style={this.getRowStyle()}
        onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func,
};

class MarketingPage extends Component {
    constructor() {
        super();
        this.state = {
          quickEntryShowError: false,
          filters: {},
          rows: [],
          selectedRows: [],
          selectedRowsIdx: null,
          marketAll:[],
          currentMarket: null,
          isAll:false,
          marketingModal: false,
          selectMarketing:[],
          url:'',
        }
    }

    componentDidMount() {
        document.title = companyCodeTitle;
        this.props.fetchMarketInfo();
    }


    componentWillReceiveProps(preProps) {
      if(preProps.marketAll.toString() != this.props.marketAll.toString() || this.state.marketAll.length == 0) {
        let marketAll = [];
        let currentMarket = null
        if(preProps.marketAll == undefined) return
          preProps.marketAll.map((item, index) => {
            if(index == 0) {
              marketAll.push({...item, checked: true, child:[]})
              this.props.fetchMarketProduct(item.id)
              currentMarket = item;
            } else {
              if(item.level == 0) {
                marketAll.push({...item, checked: false, child:[]})
              }
            }
        })
        this.setState({
          marketAll,
          currentMarket,
        })
    }
    if(preProps.productList.toString() != this.props.productList.toString() || this.state.rows.length == 0) {
      if(preProps.productList == undefined) return
      this.setState({
        rows:preProps.productList,
      })
  }
  }

    renderGroups() {
      return this.state.marketAll.map((item) => {
        return (
          <Panel key={item.id} className="panelStyle" >
            <div style={{ backgroundColor: item.checked ? APP_COLORS['active-category-background-nav']: null, fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={item.id} onClick = {()=>{this.handleClickGroup(item)}}>
              <label style={{ fontWeight: 'bold' }}>{item.Name}</label>
            </div>
            {item.checked && item.child && item.child.length > 0 && this.renderChilds(item.child)}
          </Panel>
        );
      })
    }

    renderChilds(childs) {
      return childs.map((childIt) => {
        return <li key={childIt.id} className="clickListLi" style={{ backgroundColor: childIt.checked ? APP_COLORS['active-category-background-nav']: null, fontFamily: 'Arial' }} name="category" id={childIt.id} onClick = {()=>{this.handleClickChild(childIt)}}>
          <label style={{ fontWeight: 'bold' }}>{childIt.Name}</label>
        </li>
      })
    }

    handleClickGroup(currentMarket) {
      let marketAll =[];
      if(currentMarket.id== -1) {
        this.props.fetchMarketProduct(-1)
      }
     this.props.marketAll.map((item) => {
      if(item.id == currentMarket.id) {
        this.props.fetchMarketProduct(item.id)
        let childs = [];
        if(currentMarket.child && currentMarket.child.length == 0) {
          this.props.marketAll.map((childIt) => {
            if(childIt.parent == currentMarket.id) {
              childs.push({...childIt, checked:false})
            }
          })
        }
        marketAll.push({...item, checked: true, child: childs})
      } else {
        if(item.level == 0) {
          marketAll.push({...item, checked: false, child:[]})
        }
      }
    })
    this.setState({
      currentMarket:{...currentMarket, childId: -1},
      marketAll,
      isAll: (currentMarket.id == -1)
    })
    }

    handleClickChild(child) {
      const {currentMarket, marketAll} = this.state;
      let all = [];
      let selet = {...currentMarket, childId: -1}
      marketAll.map((item) => {
        if(item.id == currentMarket.id) {
          let ch = [];
          item.child.map((chIt) => {
            if(chIt.id == child.id) {
              this.props.fetchMarketProduct(chIt.id)
              ch.push({...chIt, checked: true});
              selet.childId = chIt.id;
            } else {
              ch.push({...chIt, checked: false});
            }
          })
          all.push({...item, child:ch});
        } else {
          all.push(item);
        }
      })

      this.setState({
        marketAll: all,
        currentMarket: selet,
      })
    }

    handleModal(sl) {
      let al = [];
      this.props.marketAll.map((item)=> {
        let hav = false;
        sl.ProductMarketing_id.map((selected)=>{
          if(item.id == selected) {
            hav = true;
          }
        })
        if(hav) {
          al.push({...item, checked: true})
        } else {
          al.push({...item, checked: false})
        }
      })
      this.setState({selectMarketing: al}, () => {
        this.openMarketingModal()
      })
    }

    openMarketingModal() {
      this.setState({marketingModal: true})
    }

    closeMarketingModal() {
      this.setState({marketingModal: false})
    }

    renderExcel() {
        
        return (
          <Button
            bsStyle="success"
            type="button"
            href={this.state.url}
            onClick={()=>{
              if(this.state.rows.length == 0) {
                alert('No data currently');
                return
              }
              const {
                currentMarket,
                isAll,
              } = this.state;
              const token = localStorage.getItem('token'); + ''
              let params = `export=1&Bearer=${token}`
              if(!isAll) {
                if(currentMarket.childId && currentMarket.childId != -1) {
                  params = params + `&marketing=${currentMarket.childId}`
                } else {
                  params = params + `&marketing=${currentMarket.id}`
                }
              }
          
              const url = `${MARKET_SL_QUERY_URL}?${params}`;
              window.open(url)
            }}
            disabled={false}
          >
            <em className="fa fa-download" />
            <Translate value="excel" />
          </Button>
        );
    }

    toProductDetail(dependentValues) {
      if (checkPermission('change_product')) {
        browserHistory.push('/products/' + dependentValues.Product_id);
      } else {
        alert(I18n.t('msg_no_permission'));
      }
    }

    renderTable() {
        // Parameters of the react-data-grid
        let tableHeight = (window.innerHeight < 930) ? 680 : 739;
    
        const getRows = () => Data.Selectors.getRows(this.state);
    
        const getSize = () => getRows().length;
    
        const rowGetter = (rowIdx) => {
          const rows = getRows();
          return rows[rowIdx];
        };
    
        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          const state = Object.assign({}, this.state, { sortColumn, sortDirection });
          this.setState(state);
        };
    
        const handleFilterChange = (filter) => {
          let newFilters = Object.assign({}, this.state.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          this.setState({
            filters: newFilters,
            rows: this.props.products.map(product => ({
              ...product,
            })),
          });
        };
    
        const onClearFilters = () => {
          // all filters removed
          this.setState({
            filters: {},
            rows: this.props.products.map(product => ({
              ...product,
              IsStopSale: product.IsStopSale ? 'yes' : 'no',
            })),
          });
        };
    
        // Handle the row select function
        const onRowSelect = (rows) => {
          this.setState({ selectedRows: rows });
        };
    
        const onRowsSelected = (rows) => {
        
          let newRows = [...this.state.rows];
          let selectedRows = this.state.selectedRows;
    
          newRows.map((r) => {
            r.isSelected = false;
          });
    
          selectedRows = [];
          rows.map((row) => {
            let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
            newRows[index].isSelected = true;
            selectedRows.push(row);
          });
    
          this.setState({ rows: newRows, selectedRows, selectedRowsIdx: rows[0].rowIdx });
        };
    
        const onRowsDeselected = (rows) => {
          let newRows = [...this.state.rows];
          rows.map((row) => {
            let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
            newRows[index].isSelected = false;
          });
          let selectedRows = [];
          newRows.map((r) => {
            if (r.isSelected) { selectedRows.push(r); }
          })
          this.setState({ rows: newRows, selectedRows });
        };
    
        // Discontinued Product Background Color Formatter
        const DiscontinuedProductCellBackGroundFormatter = (props) => {
          const rowBackground = props.dependentValues.IsDiscontinued
            ? BACKGROUND_COLOR.lightGray
            : '';
          return (
            <div style={{ backgroundColor: rowBackground }}>
              <span>{ props.value }</span>
            </div>
          );
        };

        const DiscontinuedProductNumCellBackGroundFormatter = (props) => {
          const rowBackground = props.dependentValues.IsDiscontinued
            ? BACKGROUND_COLOR.lightGray
            : '';
          return (
            <div style={{ backgroundColor: rowBackground }}>
              <a onClick={()=>{this.handleModal(props.dependentValues)}}>{ props.value }</a>
            </div>
          );
        };
    
        // Column difinition
        const columns = [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
            filterRenderer: FilterByStart,
            formatter: DiscontinuedProductNumCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'GeneralNum',
            name: <Translate value={'general_no'} />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            filterRenderer: FilterByStart,
            formatter: DiscontinuedProductCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ClassNo',
            name: <Translate value="class_no" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            formatter: DiscontinuedProductCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'RefNum',
            name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
            resizable: true,
            sortable: true,
            width: 110,
            filterable: true,
            filterRenderer: FilterMultiKeyword,
            formatter: DiscontinuedProductCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'Name',
            name: <Translate value="item_name" />,
            resizable: true,
            sortable: true,
            width: 200,
            filterable: true,
            filterRenderer: FilterMultiKeyword,
            formatter: DiscontinuedProductCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 120,
            filterable: true,
            formatter: DiscontinuedProductCellBackGroundFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'PackageType',
            name: <Translate value="pkg_type" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
          },
          {
            key: 'PackageSize',
            name: <Translate value="package_size" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
          {
            key: 'MeasureUnit',
            name: <Translate value="mm_unit" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'ProductGroup_id__Name',
            name: <Translate value="prod_group" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
          {
            key: 'ProductCategory1_id__Name',
            name: <Translate value="category_1" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
          {
            key: 'ProductCategory2_id__Name',
            name: <Translate value="category_2" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
        ];
      
        return (
          <Row>
            <Col xs={12}>
              <div style={{ maxWidth: '99%' }} id="Products-dataGrid1">
              <ReactDataGrid
              ref="marketRef"
              rowRenderer={
                <RowRenderer
                  onDoubleClick={(data) => {
                    this.toProductDetail(data)
                  }
                }
                />
              }
              rowKey="d"
              onGridSort={handleGridSort}
              enableCellSelect={true}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={653}
              enableRowSelect={"single"}
              // onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
              rowSelection={{
                enableShiftSelect: false,
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
              </div>
            </Col>
          </Row>
        );
    }

    render() {
      return(
        <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="marketing" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="products-inventory-page">
          <Row>
            {/* Inventory Nav */}
            <Col xs={2}>
              <Panel id="category-nav" className="panelStyle" style={{ overflowY: 'scroll', width: '100%' }}>
                <Panel className="panelStyle" >
                  <div style={{ backgroundColor: this.state.isAll ? APP_COLORS['active-category-background-nav']: null, fontWeight: 'bold', cursor: 'pointer' }} name="group" id={-1} onClick = {()=>{this.handleClickGroup({id:-1})}}>
                    <Translate value="all" />
                  </div>
                </Panel>
                {this.state.marketAll.length > 0 && this.renderGroups()}
              </Panel>
            </Col>
            {/* End Inventory Nav */}

            {/* Main Workspace */}
            <Col xs={10}>
              <Panel className="position-relative mb0" id="products">
                <ButtonToolbar className={"table-buttons"}>
                  { this.renderExcel() }
                  {
                    this.state.quickEntryShowError &&
                    <span style={{ marginLeft: '3px', color: 'red' }}>
                      <Translate value="product_not_found" />
                      </span>
                  }
                  
                </ButtonToolbar>
                {/* Inventory Table */}
                {this.renderTable() }
              </Panel>
            </Col> {/* End Main Workspace */}
          </Row>
        </Grid>
        <SkyLightStateless
            dialogStyles={{width:'70%'}}
            isVisible={this.state.marketingModal}
            onCloseClicked={() => { this.closeMarketingModal(); }}
            title={<Translate value="Marketing" />}
          >
            <MarketingModal
              close={this.closeMarketingModal}
              all={this.state.selectMarketing}
              enableSelect={false}
            />
          </SkyLightStateless>
        </ContentWrapper>
        )
    }
}

export default MarketingPage;


// WEBPACK FOOTER //
// ./master/jsx/components/marketing/marketing.jsx